import {
    callLogsURL,
    fetchByMCQCodeAndPatientURL,
    fetchPatientsURL,
    getActiveJournalByPatientId,
    insertOrUpdatePatientURL,
    lastConnectedURL,
    lookupsURL,
    notesTemplate,
    notesURL,
    retrieveCallURL,
    tempNotesURL,
    timeTrackerURL,
    getAppointments,
    careGoalURL,
    patientCareGoalURL,
    insertMultiMcqCodeURL,
    fetchMCQDoneByIdURL,
    fetchMCQDoneURL,
    deleteMCQURL,
    activityUrl,
    fetchCareActivitiesURL,
    activityURL,
    markascompleatedMulti,
    tracker,
    getUpcomingAppointmentsURL,
    overviewURL,
    getSDOHStatusByPatientURL,
    patientsURL,
    fetchAllNotesURL,
    assessmentBreakupGraphURL,
    aiResponseURL,
    aiDisplayingURL,
    callLogsUpdate,
    aipatientHeadersURL,
    docAssisstAnswersURL,
    intimatePatientEmergencyURL,
    sendSmsToPatientURL,
    getEmergencyTemplateURL,
    callLogsPatientURL,
    intimateUserEmailURL,
    aiCaregoalURL,
    multipleActivityUrl,
    uploadPatientsXlsxURL,
    getClaimPayerListURL,
    getAssessments,
    createAssessment,
    editAssessmentUrl,
    bulkUpdateCareplanUrl,
    updateSummaryStatusURL,
    patientUploadLogURL,
    getMessageCenterTemplateURL,
    getPatientDetailsURL,
    updatePaymentsURL,
    updateMultiPaymentsURL,
    getPaymentIntentDetailsURL,
    getNotesTemplatesURL,
    itSupportEmailURL,
    hardAlertemailURL,
    getMedicationsURL,
    getConditionsURL,
    addOrUpdatePatientMedicationURL,
    addOrUpdatePatientConditionURL,
    bulkUpdatePatientMedicationURL,
    bulkUpdatePatientConditionURL,
    getPatientMedicatonURL,
    getPatientConditionURL,
    emailCCMResponse,
    journalURL,
    fetchClinicBasedBHNListURL,
    addOrUpdatePatientPaymentMethodUrl,
    updateAppointmentStatusManuallyUrl,
} from "../../apiEndPoints"
import {
    fetchPatientsFailure,
    fetchPatientsRequest,
    fetchPatientsSuccess,
    updatePatientsCount,
    updateSelectedPatient,
    updateTimeTrackerDetails,
    updatePatientNotes,
    showPatientAppointments,
    updateAssessments,
    updatePatientAssessments,
    updatePendingAssessments,
    updatePendingConsentAssessments,
    careGoal,
    updateCareActivity,
    updateActivityLogs,
    tracking,
    fetchUpcomingAppointments,
    fetchAianswers,
    updateLatestBhnRecommendations,
    updateAudios,
    fetchAIHeaders,
    updateCareGoalState,
} from "./patientSlice"
import {
    axiosDelete,
    axiosGet,
    axiosGetJournal,
    axiosLambdaGet,
    axiosPost,
    axiosPostJournal,
    axiosPut,
    axiosPutJournal,
    axiosPostCarePlanAI,
    axiosDoctoriteAiInstance,
    axiosDeleteJournal,
} from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"
import moment from "moment"
import { activityEntities } from "../../utilities/activityEntities"
import { fetchTranscripts } from "../callogs/callogActions"

export const getPatientsCount = (
    type,
    orgId,
    clinicId,
    data,
    success = null,
    failed = null,
    isAll = false
) => {
    return (dispatch, getState) => {
        let user = getState().login?.user
        const program = getState().user.program
        const searchFilter = getState().patients.searchFilter
        console.log(searchFilter, "skfjsdlf")
        const filterData = {
            ...getState().patients.filterData,
            ...searchFilter,
        }
        console.log(filterData, "kjsdfdlsf")
        // let clinic =
        //     clinicId === undefined || clinicId === ""
        //         ? user?.clinicListForUser?.[0]?.clinicId
        //         : clinicId
        // let organisation =
        //     orgId === undefined || orgId === ""
        //         ? user?.organizationListForUser &&
        //           user?.organizationlistforuser?.[0]?.organizationId
        //         : orgId
        let clinic = user?.clinicListForUser?.[0]?.clinicId
        // let org = getState().organisations?.selectedOrg
        let organisation = user?.organizationListForUser?.[0]?.organizationId
        var dataSource = {
            source: "PORTAL",
            // clinicId: clinic,
            // organizationId: organisation,
        }

        if (!isAll) {
            dataSource.clinicId = clinic
            dataSource.organizationId = organisation
        }

        // add all filters for active and inactive patients
        {
            type !== "deleted" &&
                type !== "manualConsentPending" &&
                Object.keys(filterData).map(key => {
                    if (filterData[key] !== null && key != "sms") {
                        dataSource[key] = filterData[key]
                    }
                })
        }

        // add only search filter for deleted and manual consent pending patients
        if (type === "deleted" || type === "manualConsentPending") {
            if (filterData?.programDesc)
                dataSource.programDesc = filterData.programDesc
            if (type === "manualConsentPending" && filterData?.sms?.id)
                dataSource.sms = filterData.sms.id
            if (filterData.hasOwnProperty("ehrPatientId")) {
                dataSource["ehrPatientId"] = filterData.ehrPatientId
            } else if (filterData.hasOwnProperty("searchByName")) {
                dataSource.searchByName = filterData.searchByName
            } else if (filterData.hasOwnProperty("email")) {
                dataSource.email = filterData.email
            }
        }

        if (dataSource.consentLaterDate == "Invalid date") {
            delete dataSource.consentLaterDate
        }

        let url = fetchPatientsURL + `?isCount=true&programId=${program.id}`

        if (type) {
            if (type === "active") {
                dataSource.isActive = true
                // dataSource.receivedConsent = "Yes"
                delete dataSource.consentLaterDate
            } else if (type === "new") {
                console.log(dataSource, "fjlsflsdf")
                dataSource.isActive = false
                //dataSource.receivedConsent = "null"
                url += "&isDeleted=false"
                //dataSource.isDeleted = false
            } else if (type == "deleted") {
                url += "&isDeleted=true"

                // dataSource.isDeleted = true
                delete dataSource.consentLaterDate
            } else {
                url += "&manualConsentPending=true"
            }
        }

        dispatch(logTransaction("Fetch Patients", dataSource))
        dispatch(fetchPatientsRequest())

        axiosPost(url, dataSource)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(updatePatientsCount(response.data.responseData))
                    success && success(type, response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch Patient Count success",
                            dataSource
                        )
                    )
                } else {
                    failed && failed(type)
                    dispatch(updatePatientsCount(0))
                    dispatch(
                        logTransaction(
                            "Fetch Patient Count failure",
                            dataSource
                        )
                    )
                }
            })
            .catch(err => {
                failed && failed(type)
                dispatch(updatePatientsCount(0))
                dispatch(logTransaction("Error in Fetch Patient Count", err))
            })
    }
}

export function fetchClaimPayerList(success, failure) {
    return function (dispatch, getState) {
        let url = getClaimPayerListURL
        axiosGet(url).then(response => {
            if (response.data.statusCD === 200) {
                success(response?.data?.responseData)
            } else {
                failure("Failed to fetch claim payers list")
            }
        })
    }
}

export const fetchPatients = (
    type,
    orgId,
    clinicId,
    data,
    pageNo,
    pageSize,
    success,
    failure,
    isAll = false
) => {
    // console.log("fetchPatients dataSource", dataSource)
    return (dispatch, getState) => {
        dispatch(fetchPatientsSuccess([]))
        let user = getState().login?.user
        const program = getState().user.program
        const searchFilter = getState().patients.searchFilter
        const filterData = {
            ...getState().patients.filterData,
            ...searchFilter,
        }
        // let clinic =
        //     clinicId === undefined || clinicId === ""
        //         ? user?.clinicListForUser?.[0]?.clinicId
        //         : clinicId
        // let organisation =
        //     orgId === undefined || orgId === "" || orgId === 0
        //         ? user?.organizationListForUser &&
        //           user?.organizationlistforuser?.[0]?.organizationId
        //         : orgId
        // let clinic = getState().clinics.selectedClinic
        console.log(user, "kdsjfsjdflsjflsdfj")
        let clinic = user?.clinicListForUser?.[0]?.clinicId
        // let org = getState().organisations?.selectedOrg
        let organisation = user?.organizationListForUser?.[0]?.organizationId
        var dataSource = {
            source: "PORTAL",
        }

        if (!isAll) {
            dataSource.clinicId = clinic
            dataSource.organizationId = organisation
        }

        // add all filters
        {
            type !== "deleted" &&
                type !== "manualConsentPending" &&
                Object.keys(filterData).map(key => {
                    console.log(key, key != "sms", "lsfjdsljfldsjfl")
                    if (filterData[key] !== null && key != "sms") {
                        dataSource[key] = filterData[key]
                    }
                })
        }

        // add only search filter
        if (type === "deleted" || type == "manualConsentPending") {
            if (filterData?.programDesc)
                dataSource.programDesc = filterData.programDesc
            if (type === "manualConsentPending" && filterData?.sms?.id) {
                console.log(filterData.sms, "jdlfjsl;dfjls")
                dataSource.sms = filterData.sms.id
            }
            if (filterData.hasOwnProperty("ehrPatientId")) {
                dataSource["ehrPatientId"] = filterData.ehrPatientId
            } else if (filterData.hasOwnProperty("searchByName")) {
                dataSource.searchByName = filterData.searchByName
            } else if (filterData.hasOwnProperty("email")) {
                dataSource.email = filterData.email
            }
        }
        let url =
            fetchPatientsURL +
            `?pageNo=${pageNo}&pageSize=${pageSize}&programId=${program.id}`
        if (dataSource.consentLaterDate == "Invalid date") {
            console.log(dataSource.consentLaterDate, "dsfjldjfl")
            delete dataSource.consentLaterDate
        }
        if (type) {
            if (type === "active") {
                dataSource.isActive = true
                // dataSource.receivedConsent = "Yes"
                delete dataSource.consentLaterDate
            } else if (type === "new") {
                console.log(dataSource, "slkfjdslfj")
                dataSource.isActive = false
                //dataSource.receivedConsent = "null"
                url += "&isDeleted=false"
                //dataSource.isDeleted = false
            } else if (type === "deleted") {
                url += "&isDeleted=true"
                // dataSource.isDeleted = true
                delete dataSource.consentLaterDate
            } else {
                url += "&manualConsentPending=true"
            }
        }
        dispatch(logTransaction("Fetch Patients", dataSource))
        dispatch(fetchPatientsRequest())

        axiosPost(url, dataSource)
            .then(response => {
                if (response.data.statusCD === 200) {
                    var patients = response.data.responseData || []
                    dispatch(logTransaction("Fetch Patients", response))
                    dispatch(fetchPatientsSuccess(patients))
                    success && success()
                } else {
                    dispatch(logTransaction("Fetch Patients", response))
                    dispatch(fetchPatientsFailure(response.data.statusMSG))
                    failure && failure(response.data.statusMSG || "")
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Patients failure", err))
                dispatch(fetchPatientsFailure(err.message))
                failure && failure("Failed to fetch patients")
            })
    }
}

export const fetchAllPatients = (
    orgId,
    clinicId,
    success,
    failure,
    pageNo,
    pageSize,
    filterData
) => {
    // console.log("fetchPatients dataSource", dataSource)
    return (dispatch, getState) => {
        var dataSource = {
            source: "PORTAL",
        }

        if (orgId) dataSource.organizationId = orgId
        if (clinicId) dataSource.clinicId = clinicId

        let url = fetchPatientsURL + `?pageNo=${pageNo}&pageSize=${pageSize}`

        if (filterData.hasOwnProperty("status")) {
            dataSource.isActive = filterData.status
        }

        if (filterData?.search) {
            dataSource.searchByName = filterData.search
        }

        if (filterData?.programId) {
            url += `&programId=${filterData.programId}`
        }

        axiosPost(url, dataSource)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Fetch Patients", response))
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Fetch Patients", response))
                    failure && failure(response.data.statusMSG || "")
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Patients failure", err))
                failure && failure("Failed to fetch patients")
            })
    }
}

export const fetchPatient = (
    user,
    success = () => {},
    failure = () => {},
    page,
    rowsPerPage
) => {
    console.log(user, "jhdwhef")
    return (dispatch, getState) => {
        try {
            const dataSource = {
                source: "PORTAL",
                patientId: user?.patientId || user?.patient_id,
            }
            let program = getState().user?.program
            let userData = getState().login.user
            let clinic = user.clinic_id
                ? user?.clinic_id
                : userData?.clinicListForUser?.[0]?.clinicId
            // let org = getState().organisations?.selectedOrg
            let organisation = user.organization_id
                ? user.organization_id
                : userData?.organizationListForUser?.[0]?.organizationId

            let url = fetchPatientsURL + `?programId=${program.id}`
            // if (user?.organizationId) url += `&orgId=${organisation}`
            url += `&orgId=${organisation}`
            // if (user?.clinicId) url += `&clinicId=${clinic}`
            url += `&clinicId=${clinic}`

            if (user?.isDeleted !== undefined && user?.isDeleted !== null) {
                url += `&isDeleted=${user.isDeleted}`
            }

            if (
                user?.patientProgramsList?.filter(
                    item => item?.programId == program.id
                )?.[0]?.isDeleted
            ) {
                url += `&isDeleted=true`
            }

            axiosPost(url, dataSource, {
                userType: "patient",
            })
                .then(response => {
                    if (response.data.statusCD === 200) {
                        console.log(response.data.responseData[0], "jhdwhef")
                        success(response.data.responseData[0])
                        if (user?.dontUpdateGlobal) return
                        dispatch(
                            updateSelectedPatient(response.data.responseData[0])
                        )
                        dispatch(
                            logTransaction(
                                "Fetch patient successfull",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    console.log(err, "jhdwhef")
                    failure()
                    if (!user?.dontUpdateGlobal) {
                        dispatch(updateSelectedPatient({}))
                    }
                    dispatch(logTransaction("Fetch patient unsuccessfull", err))
                })
        } catch (err) {
            console.log(err, "jhdwhef")
            failure()
        }
    }
}

export const fetchPatientByUserId = (
    userId,
    success = () => {},
    failure = () => {},
    page,
    rowsPerPage
) => {
    // console.log(user, "jhdwhef")
    return (dispatch, getState) => {
        const dataSource = {
            source: "PORTAL",
            userId: userId,
        }

        let program = getState().user?.program

        let url = fetchPatientsURL + `?programId=${program.id}`
        // if (user?.isDeleted !== undefined && user?.isDeleted !== null) {
        //   url += `?isDeleted=${user.isDeleted}`
        // }
        axiosPost(url, dataSource)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData[0])
                    dispatch(
                        updateSelectedPatient(response.data.responseData[0])
                    )
                    dispatch(
                        logTransaction("Fetch patient successfull", response)
                    )
                }
            })
            .catch(err => {
                failure()
                dispatch(updateSelectedPatient({}))
                dispatch(logTransaction("Fetch patient unsuccessfull", err))
            })
    }
}

export const fetchingPatientById = (
    id,
    success = () => {},
    failure = () => {}
) => {
    return function (dispatch, getState) {
        console.log("ldfjldsjfldfjlsdjf")
        let program = getState().user?.program
        let user = getState().login.user
        let clinic = user?.clinicListForUser?.[0]?.clinicId
        // let org = getState().organisations?.selectedOrg
        let organisation = user?.organizationListForUser?.[0]?.organizationId
        let url =
            fetchPatientsURL +
            `?programId=${program.id}&clinicId=${clinic}&orgId=${organisation}`
        axiosPost(url, { userId: id, clinicId: clinic, orgId: organisation })
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData != null
                ) {
                    // let data = response.data.responseData;
                    console.log(response.data.responseData, "dlkjfslkfjld")
                    dispatch(
                        updateSelectedPatient(response.data.responseData[0])
                    )
                    success()
                    dispatch(logTransaction("Fetch patient by id", response))
                } else {
                    dispatch(
                        logTransaction("Fetch patient by id error", response)
                    )
                    failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch patient by id failure", err))
                failure()
            })
    }
}

export function insertTimeTracker(patientUserId) {
    return function (dispatch, getState) {
        let user = getState().login.user
        let userId = user?.profileForUser[0]?.userId
        let program = getState().user?.program

        let payload = {
            userId: userId,
            patientUserId: patientUserId,
            programId: program.id,
        }

        axiosPost(timeTrackerURL, payload)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response insert time tracker.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Insert Time Tracker", payload))
                    dispatch(
                        updateTimeTrackerDetails(response.data.responseData)
                    )
                } else {
                    dispatch(logTransaction("Insert Time Tracker", payload))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert Time Tracker", err))
            })
    }
}

export function updateTimeTracker(
    reset = true,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let timeTrackerId = getState().patients.timeTracker.id
        const program = getState().user.program
        let payload = {
            // endTime: moment().format("YYYY-MM-DD HH:mm:ss")
        }
        let url =
            timeTrackerURL + `/${timeTrackerId}/end?programId=${program.id}`
        console.log("input dataaa", payload)
        axiosPut(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log("response update time tracker.......", response)
                    dispatch(logTransaction("Update Time Tracker", payload))
                    reset && dispatch(updateTimeTrackerDetails({}))
                    success(response.data.responseData)
                } else {
                    failure()
                    dispatch(logTransaction("Update Time Tracker", payload))
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Update Time Tracker", err))
            })
    }
}

export function fetchByMCQCodeAndPatient(patientId, mcqCode, success, failed) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(
            `${fetchByMCQCodeAndPatientURL}/?patientId=${patientId}&mcqCode=${mcqCode}&programId=${program.id}`
        )
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        logTransaction(
                            "fetch by MCQ code and patient",
                            response,
                            patientId
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "fetch by MCQ code and patient error",
                            response,
                            patientId
                        )
                    )
                    failed("")
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction(
                        "fetch by MCQ code and patient failed",
                        err,
                        patientId
                    )
                )
                failed("")
            })
    }
}

export function fetchUserJournalActivities(
    patientUserId,
    page,
    rowsPerPage,
    success,
    failure
) {
    console.log("pageeeeeeeeeeeee", page, rowsPerPage)
    return function (dispatch, getState) {
        if (typeof page !== "number") return
        dispatch(updateCareGoalState([]))
        let program = getState().user?.program
        axiosGetJournal(
            patientCareGoalURL +
                `/${patientUserId}?pageNo=${page}&pageSize=${rowsPerPage}&programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    let data = response.data && response.data.responseData
                    console.log("responseee data", data)
                    dispatch(careGoal(response.data.responseData))

                    success(data)
                } else {
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction(
                        "fetch User Journal Activities failure",
                        err,
                        patientUserId
                    )
                )
            })
    }
}

export function countJournalActivities(patientUserId, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGetJournal(
            patientCareGoalURL +
                `/${patientUserId}?isCount=true&programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                    dispatch(
                        logTransaction("fetch User Journal Activities failure")
                    )
                }
            })
            .catch(err => {
                failure()
                dispatch(
                    logTransaction("fetch User Journal Activities failure", err)
                )
            })
    }
}

export function fetchTracker(data, success, failure) {
    return function (dispatch, getState) {
        console.log(data, "data in fetch tracker")
        let program = getState().user?.program
        axiosGetJournal(
            tracker +
                `?patientUserId=${data.patientUserId}&categoryId=${data.catergoryId}&journalId=${data.journalId}&${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    let data = response.data && response.data.responseData
                    console.log("responseee data", data)
                    dispatch(tracking(response.data.responseData))
                    success(data)
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure()
                dispatch(
                    logTransaction(
                        "fetch User Journal Activities failure",
                        err,
                        data.patientId
                    )
                )
            })
    }
}

export function markJournalCompleteMulti(data, success, failed) {
    return function (dispatch) {
        let url = data.reduce((acc, curr) => {
            return (
                acc +
                (curr.selectedStatus === "completed"
                    ? `journalTrackerIdsCompleated=${curr.trackerId}&`
                    : `journalTrackerIdsDeclined=${curr.trackerId}&`)
            )
        }, `${markascompleatedMulti}?`)
        // let url = `${markascompleatedMulti}?journalTrackerIdsCompleated=${data}`
        console.log("url", url)
        axiosPutJournal(url, {})
            .then(response => {
                if (response.data.statusCD == 200) {
                    console.log("In mark success")
                    success()
                    dispatch(
                        logTransaction(
                            "Mark Multi Journal tracker complete success"
                        )
                    )
                } else {
                    failed()
                    console.log("In mark failure")
                    dispatch(
                        logTransaction("Mark Multi Journal Tracker failed")
                    )
                }
            })
            .catch(err => {
                failed()
                console.log("in mark error", err)
                dispatch(
                    logTransaction("Mark Journal Multi Tracker error", err)
                )
            })
    }
}

export function fetchUserCareActivities(
    goalId,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGetJournal(
            fetchCareActivitiesURL + `/${goalId}?programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    let data =
                        response.data &&
                        response.data.responseData.map(res => ({
                            ...res,
                            category: {
                                ...res.categoryId,
                                lookupId: res.categoryId.id,
                                lookupDescription: res.categoryId.description,
                                lookupValue: res.categoryId.description,
                                lookupNotes: res.categoryId.logoUrl,
                            },
                        }))
                    console.log("responseee data", data)
                    dispatch(
                        updateCareActivity([
                            ...getState().patients.careActivity,
                            { id: goalId, data: response.data.responseData },
                        ])
                    )

                    success(data)
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "fetch User Journal Activities error",
                            response,
                            goalId
                        )
                    )
                }
            })
            .catch(err => {
                failure()
                dispatch(
                    logTransaction(
                        "fetch User Journal Activities failure",
                        err,
                        goalId
                    )
                )
            })
    }
}

export function insertCallLogs(data, success, failure) {
    console.log(data, "ksdjfljfls")
    return function (dispatch, getState) {
        const program = getState().user.program
        axiosPost(callLogsURL, { ...data, programId: program.id })
            .then(response => {
                if (response.data.statusCD === 200) {
                    success && success(response.data.responseData)
                    dispatch(logTransaction("Insert Call Logs", response))
                }
            })
            .catch(err => {
                failure && failure()
                dispatch(logTransaction("Insert Call Logs Failure", err))
            })
    }
}

export function updateCallLog(inputData, success, failure) {
    return function (dispatch, getState) {
        console.log(getState().callogs.callLogId, "sdjfksdfl")
        let input = { ...inputData }
        // let url = callLogsUpdate + `/${inputData.id}`
        let url = callLogsUpdate
        if (inputData?.id !== undefined) {
            url += `/${inputData.id}`
        } else {
            url += `/${getState().callogs.callLogId.id}`
            const callLogDetails = getState().callogs.callLogId
            input = { ...callLogDetails }
            input.endTime = inputData.endTime
            input.status = inputData.status
        }
        axiosPut(url, input, { "Content-Type": "application/json" })
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response update notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Update Notes", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Update Notes failure", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update Notes Failure", err))
                failure(err.message)
            })
    }
}

export function updateAudioLog(inputData, success, failure) {
    return function (dispatch, getState) {
        let url =
            "conversation/media/updatingRating" +
            `/${inputData.id}?rating=${inputData.callRating}`
        axiosPut(url, { "Content-Type": "application/json" })
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response update notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Update rating", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Update rating failure", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update rating Failure", err))
                failure(err.message)
            })
    }
}

export function retriveTwilioCall(sid, success) {
    return function (dispatch, getState) {
        let url = `${retrieveCallURL}${sid}`
        axiosLambdaGet(url)
            .then(response => {
                success(response.data)
                dispatch(
                    logTransaction("Retrieve Twilio Call Success", response)
                )
            })
            .catch(err => {
                dispatch(logTransaction("Retrieve Twilio Call Failed", err))
            })
    }
}

export function fetchCommunicationHistory(patientId, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = lastConnectedURL + `/${patientId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                success(response.data.responseData)
                dispatch(
                    logTransaction(
                        "Retrieve communication history success",
                        response
                    )
                )
            })
            .catch(err => {
                failure()
                dispatch(
                    logTransaction("Retrieve communication history failed", err)
                )
            })
    }
}

export function insertOrUpdatePatient(data, success, failed) {
    return function (dispatch, getState) {
        let user = getState().login.user
        let inputData = {
            ...data,
            organizationId:
                data?.organizationId === undefined ||
                data?.organizationId === ""
                    ? user?.organizationlistforuser?.[0]?.organizationId
                    : data?.organizationId,
            clinicId:
                data?.clinicId === undefined || data?.cliniId === ""
                    ? user?.clinicListForUser?.[0]?.clinicId
                    : data?.clinicId,
        }
        console.log("input data", inputData)

        axiosPost(insertOrUpdatePatientURL, inputData)
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log(response.data.responseData, "klsdjfldsjfldjfl")
                    dispatch(
                        updateSelectedPatient({
                            ...getState().patients.selectedPatient,
                            ...response.data.responseData,
                        })
                    )
                    dispatch(
                        logTransaction(
                            "Insert or update Patient success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Insert or update Patient success failed",
                            response
                        )
                    )
                    failed(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Insert or update Patient failure", err)
                )
                failed(err.message)
            })
    }
}

// export function fetchNotesCategory(success, failed) {
//     return function (dispatch, getState) {
//         let user = getState().login.user
//         let orgId =
//             user?.organizationListForUser &&
//             user?.organizationlistforuser?.[0]?.organizationId
//         let url = lookupsURL + `?lookupCategoryId=${10066}&appLanguageId=1`
//         if (orgId !== null && orgId !== undefined) {
//             url = url + `&organizationId=${orgId}`
//         }
//         axiosGet(url)
//             .then(response => {
//                 if (
//                     response.data.statusCD === 200 &&
//                     response.data.responseData
//                 ) {
//                     console.log(
//                         "response-------------------->>>>>>>>>>>>",
//                         response.data.responseData
//                     )
//                     dispatch(logTransaction("fetch Notes Category", response))
//                     success(response.data.responseData)
//                 }
//             })
//             .catch(err => {
//                 failed(err)
//                 dispatch(logTransaction("fetch Notes Category failure", err))
//             })
//     }
// }

export function getNotesTemplates(success, failed) {
    return function (dispatch, getState) {
        // let user = getState().login.user
        // let orgId =
        //     user?.organizationListForUser &&
        //     user?.organizationlistforuser?.[0]?.organizationId
        // let url = lookupsURL + `?lookupCategoryId=${10066}&appLanguageId=1`
        // if (orgId !== null && orgId !== undefined) {
        //     url = url + `&organizationId=${orgId}`
        // }
        let program = getState().user?.program
        const url = getNotesTemplatesURL + `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response-------------------->>>>>>>>>>>>",
                        response.data.responseData
                    )
                    dispatch(logTransaction("fetch Notes Category", response))
                    success(response.data.responseData)
                } else {
                    success([])
                }
            })
            .catch(err => {
                failed(err)
                dispatch(logTransaction("fetch Notes Category failure", err))
            })
    }
}

export function getNotesTemplate(eventName, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url =
            notesTemplate +
            `?isNotes=true&eventName=${eventName}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200 && response.data) {
                    success(response.data.responseData)
                    dispatch(logTransaction("fetch Notes Template", response))
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefucsfdcgsabdcub")
                failure()
                dispatch(logTransaction("fetch Notes Template failure", err))
            })
    }
}

export function fetchNotes(userId, success, failure) {
    return (dispatch, getState) => {
        dispatch(updatePatientNotes([]))
        let program = getState().user?.program
        // .get(fetchCompletedByCategory + `?patientId=${journal.patientId}&categoryId=${journal.category.lookupId}&journalId=${journal.id}`)
        axiosGet(notesURL + `?patientUserId=${userId}&programId=${program.id}`)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        logTransaction("Fetch Notes History", response, userId)
                    )
                    dispatch(
                        updatePatientNotes(
                            response.data.responseData.filter(
                                note => !note.isDeleted
                            )
                        )
                    )
                    success &&
                        success(
                            response.data.responseData.filter(
                                note => !note.isDeleted
                            )
                        )
                } else {
                    dispatch(updatePatientNotes([]))
                    dispatch(
                        logTransaction(
                            "Fetch Notes History Error",
                            response,
                            userId
                        )
                    )
                    failure && failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(updatePatientNotes([]))
                failure && failure("Error occured while fetching notes")
                dispatch(
                    logTransaction("Fetch Notes History Error", err, userId)
                )
            })
    }
}

export function insertNotes(inputData, success, failure) {
    return function (dispatch, getState) {
        console.log("input dataaa", inputData)
        let program = getState().user?.program
        axiosPost(
            notesURL,
            JSON.stringify([{ ...inputData[0], programId: program.id }])
        )
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response insert notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Insert Notes", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Insert Notes failure", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert Notes Failure", err))
                failure(err.message)
            })
    }
}

export function addActivity(inputData, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosPostJournal(
            activityUrl,
            { ...inputData, programId: program.id },
            {
                "Content-Type": "application/json",
                AppLanguageId: "1",
            }
        )
            .then(response => {
                console.log(response, "response in add activity")
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    dispatch(logTransaction("activity", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("activity failure", response))
                    failure(response)
                }
            })
            .catch(err => {
                console.log(err, "show me the error man")
                dispatch(logTransaction("activity Failure", err))
                failure(err.message)
            })
    }
}

export function addMultipleActivities(inputData, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosPostJournal(multipleActivityUrl, inputData, {
            "Content-Type": "application/json",
            AppLanguageId: "1",
        })
            .then(response => {
                console.log(response, "response in add activity")
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    dispatch(logTransaction("activity", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("activity failure", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("activity Failure", err))
                failure(err.message)
            })
    }
}

export function insertTempNotes(inputData, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = tempNotesURL
        axiosPost(url, { ...inputData, programId: program.id })
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log(
                        "response insertTemp notes.......",
                        response.data.responseData
                    )
                    console.log("This is success")
                    dispatch(
                        logTransaction("Insert Temp Notes success", response)
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction("Insert Temp Notes failure", response)
                    )
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert  Temp Notes Failure", err))
                console.log(err, "Insert  Temp Notes Failure")
                failure("Error occured while inserting temp notes")
            })
    }
}

export function updateTempNotesFunc(inputData, success, failure) {
    return function (dispatch, getState) {
        console.log("input dataaa", inputData)
        let url = tempNotesURL + `/${inputData.id}`
        axiosPut(url, inputData, { "Content-Type": "application/json" })
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response update notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Update temp Notes", response))
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction("Update temp Notes failure", response)
                    )
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update temp Notes Failure", err))
                failure(err.message)
            })
    }
}

export function updateNotesFunc(inputData, success, failure) {
    return function (dispatch, getState) {
        console.log("input dataaa", inputData)
        let url = notesURL + `/${inputData.id}`
        axiosPut(url, inputData, { "Content-Type": "application/json" })
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response update notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Update Notes", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Update Notes failure", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update Notes Failure", err))
                failure(err.message)
            })
    }
}

export function patientAppointmentListingCount(
    data,
    appointmentSuccess,
    appointmentFailure
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const selectedPatient = getState().patients.selectedPatient
        let url =
            getAppointments +
            `?users=${
                selectedPatient.userId
            }&isCount=true&programId=${program.id}&clinicId=${
                selectedPatient?.clinicId
            }&orgId=${selectedPatient?.organizationId}`
        if (data?.status) url += `&status=${data.status}`
        if (data?.startDate && data?.endDate)
            url += `&startDate=${data.startDate}&endDate=${data.endDate}`
        if (data?.searchStatuses)
            url += `&searchStatuses=${data?.searchStatuses}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (response?.data?.responseData !== null) {
                    dispatch(
                        logTransaction(
                            "Fetch patients appointments count success",
                            response
                        )
                    )
                    appointmentSuccess &&
                        appointmentSuccess(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Fetch patients appointments count success Failed",
                            response
                        )
                    )
                    appointmentSuccess && appointmentSuccess(0)
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction(
                        "Fetch patients appointments count success Failed",
                        err
                    )
                )
                appointmentFailure && appointmentFailure()
            })
    }
}

export function patientAppointmentListing(
    data,
    appointmentSuccess,
    appointmentFailure,
    page = 0,
    pageSize = 10
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const selectedPatient = getState().patients.selectedPatient
        let url =
            getAppointments +
            `?users=${
                selectedPatient.userId
            }&pageNo=${page}&pageSize=${pageSize}&programId=${
                program.id
            }&clinicId=${selectedPatient?.clinicId}&orgId=${
                selectedPatient?.organizationId
            }&sortDirection=${data?.sortDirection || "DESC"}`
        if (data?.status) url += `&status=${data.status}`
        if (data?.searchStatuses)
            url += `&searchStatuses=${data?.searchStatuses}`
        if (data?.startDate && data?.endDate)
            url += `&startDate=${data.startDate}&endDate=${data.endDate}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        showPatientAppointments(response.data.responseData)
                    )
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                    appointmentSuccess &&
                        appointmentSuccess(response.data.responseData)
                } else {
                    dispatch(showPatientAppointments([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                    appointmentSuccess && appointmentSuccess()
                }
            })
            .catch(err => {
                dispatch(showPatientAppointments([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
                appointmentFailure && appointmentFailure()
            })
    }
}

export function fetchAssessments(
    id = null,
    success = () => {},
    failure = () => {},
    includeArchived = false
) {
    return function (dispatch, getState) {
        let user = getState().login.user
        const patient = getState().patients.selectedPatient
        let program = getState().user?.program
        const orgId = patient.organizationId
        const clinicId = patient.clinicId
        let url = getAssessments + `?appLanguageId=1&programId=${program.id}`
        if (id) {
            url = url + `&organizationId=${id}`
        } else if (orgId !== null && orgId !== undefined) {
            url = url + `&organizationId=${orgId}`
        }
        if (clinicId !== null && clinicId !== undefined) {
            url = url + `&clinicId=${clinicId}`
        }
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response-------------------->>>>>>>>>>>>",
                        response.data.responseData
                    )
                    let array = response.data.responseData.map(assessment => ({
                        ...assessment,
                        lookupDescription: assessment.description,
                        lookupCategory: { id: 10045 },
                        lookupCategoryId: 10045,
                        status: assessment.isActive,
                        lookupId: assessment.mcqCode,
                        lookupNotes: assessment.url,
                    }))
                    if (!includeArchived) {
                        array = array.filter(l => l.status)
                    }
                    dispatch(logTransaction("fetch Assessments", response))
                    dispatch(updateAssessments(array))
                    success(array)
                } else {
                    failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("fetch Assessments failure", err))
                failure()
            })
    }
}

export function createCarePlan(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = careGoalURL
        axiosPostJournal(
            url,
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                if (response.data.responseData) {
                    dispatch(
                        logTransaction("Create Care goal success", response)
                    )
                    success(response.data.responseData)
                }
            })
            .catch(err => {
                failure && failure()
                // alert("Goal creation unsuccessfull")
                console.log(err, "created care giak")
                dispatch(logTransaction("Create care goal failed", err))
            })
    }
}

export function updateCarePlan(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = careGoalURL + `?programId=${program.id}`
        axiosPutJournal(url, data, { "Content-Type": "application/json" })
            .then(response => {
                if (response.data.responseData) {
                    dispatch(
                        logTransaction("update Care goal success", response)
                    )
                    success(response.data.responseData)
                }
            })
            .catch(err => {
                failure && failure()
                dispatch(logTransaction("update care goal failed", err))
            })
    }
}

export function insertMultiMcqCode(payload, success, failed) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = insertMultiMcqCodeURL + `?programId=${program.id}`
        axiosPost(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(logTransaction("Insert Multi MCQ code", response))
                    success(response.data.statusMSG, response.data.responseData)
                } else {
                    dispatch(logTransaction("Insert Multi MCQ code", response))
                    failed(
                        response.data?.statusMSG ||
                            "Failed to insert assessment"
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert Multi MCQ code", err))
                failed(err?.message || "Failed to insert assessment")
            })
    }
}

export function fetchGendersList(success, failure) {
    return function (dispatch, getState) {
        let url = lookupsURL + `?lookupCategoryId=${10003}&appLanguageId=1`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    // console.log(
                    //   "response-------------------->>>>>>>>>>>>",
                    //   response.data.responseData
                    // )
                    dispatch(logTransaction("fetch Genders Success", response))
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch genders")
                    dispatch(logTransaction("fetch genders failure", response))
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("fetch genders failure", err))
            })
    }
}

export function fetchMCQDoneById(userId, completed, success, failed) {
    return function (dispatch, getState) {
        dispatch(updatePatientAssessments([]))
        let program = getState().user?.program
        let url = `${fetchMCQDoneByIdURL}/${userId}?programId=${program.id}`
        if (completed !== null) url += `&completed=${completed}`
        axiosGet(url)
            .then(response => {
                if (response && response.data) {
                    if (
                        response.data.statusCD == 200
                        // response.data.responseData &&
                        // response.data.responseData.length > 0
                    ) {
                        dispatch(
                            logTransaction(
                                "fetch MCQ done by id",
                                response,
                                userId
                            )
                        )
                        const allAssessments =
                            response?.data?.responseData?.filter(
                                item => item.mcqCode !== 100450036
                            ) || []
                        dispatch(updatePatientAssessments(allAssessments))
                        // When the full list is fetched (completed === null),
                        // refresh the pending assessment/form counts that drive
                        // the Assessments tab badge, so completing an item clears
                        // it instead of leaving a stale "pending" badge.
                        if (completed === null) {
                            const pending = allAssessments.filter(
                                item => !item.completed
                            )
                            dispatch(
                                updatePendingAssessments(
                                    pending.filter(item => !item.isConsent)
                                )
                            )
                            dispatch(
                                updatePendingConsentAssessments(
                                    pending.filter(item => item.isConsent)
                                )
                            )
                        }
                        success(response.data.responseData || [])
                    } else {
                        dispatch(
                            logTransaction(
                                "fetch MCQ done by id",
                                response,
                                userId
                            )
                        )
                        // failed("No assessments available")
                    }
                }
            })
            .catch(err => {
                console.log(err, "ksjfldkfjl")
                dispatch(logTransaction("fetch MCQ done by id", err, userId))
                failed("Failed to fetch assessments")
            })
    }
}

export function fetchMoodAssessments(success, failure, id) {
    return function (dispatch, getState) {
        let user = getState().login.user
        let organizationId = user?.organizationlistforuser?.[0]?.organizationId
        let program = getState().user?.program
        let url = getAssessments + `?appLanguageId=1&programId=${program.id}`
        if (id) {
            url = url + `&organizationId=${id}`
        } else if (organizationId !== null && organizationId !== undefined) {
            url = url + `&organizationId=${organizationId}`
        }
        axiosGet(url, {})
            .then(response => {
                console.log(
                    "response-------------------->>>>>>>>>>>>",
                    response.data.responseData
                )
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData.length > 0
                ) {
                    let array = response.data.responseData
                        .map(assessment => ({
                            ...assessment,
                            lookupDescription: assessment.description,
                            lookupCategory: { id: 10045 },
                            lookupCategoryId: 10045,
                            status: assessment.isActive,
                            lookupId: assessment.mcqCode,
                            lookupNotes: assessment.url,
                        }))
                        .filter(l => l.status)
                    // dispatch(updateMoodAssessments(array))
                    success(array)
                    dispatch(logTransaction("Fetch Mood Assessments", url))
                }
            })
            .catch(error => {
                console.log("error", error)
                failure([])
                dispatch(logTransaction("Fetch Mood Assessments Failed", url))
            })
    }
}

export function updateMcqDone(patientUserId, data, success, failure) {
    return function (dispatch, getState) {
        let user = getState().login.user
        let userId = user?.profileForUser[0]?.portalUserId
            ? user?.profileForUser[0]?.portalUserId
            : user?.profileForUser[0]?.id
        console.log("Update MCQ done", data)
        let url = fetchMCQDoneURL + `/${data.id}`
        let payload = {
            patientUserId: patientUserId,
            id: data.id,
            mcqName: data.mcqName,
            score: data.score,
            url: data.url,
            mcqCode: data.mcqCode,
            completed: data.completed,
            categoryCodes: data.categoryCodes,
            scores: data.scores,
        }
        console.log("***Payload***", payload)
        axiosPut(url, payload)
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log(
                        "response-------------------->>>>>>>>>>>>",
                        response
                    )
                    success(response.data.responseData)
                    dispatch(logTransaction("Update MCQ Done", response))
                } else {
                    console.log(
                        "response-------------------->>>>>>>>>>>>",
                        response
                    )
                    failure()
                    dispatch(logTransaction("Update MCQ Done", response))
                }
            })
            .catch(error => {
                failure()
                console.log("error", error)
                dispatch(logTransaction("Fetch MCQ Done Failed", error))
            })
    }
}

export function deleteMCQ(id, success, failure) {
    return function (dispatch, getState) {
        const url = deleteMCQURL + `/${id}`
        axiosDelete(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(logTransaction("Delete mcq success", response))
                    success()
                } else {
                    dispatch(logTransaction("Delete mcq success", response))
                    failure()
                }
            })
            .catch(error => {
                console.log("error", error)
                dispatch(logTransaction("Delete mcq success", error))
                failure()
            })
    }
}

export function fetchMoodAssessmentLevels(lookupCategoryId, success) {
    return function (dispatch, getState) {
        let user = getState().login.user
        let organizationId = user?.organizationlistforuser?.[0]?.organizationId
        let program = getState().user?.program
        let url =
            lookupsURL +
            `?lookupCategoryId=${lookupCategoryId}&appLanguageId=1&programId=${program.id}`
        if (organizationId !== null && organizationId !== undefined) {
            url = url + `&organizationId=${organizationId}`
        }
        axiosGet(url, {})
            .then(response => {
                console.log(
                    "response-------------------->>>>>>>>>>>>",
                    response.data.responseData
                )
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData.length > 0
                ) {
                    let array = response.data.responseData.filter(l => l.status)
                    success(array)
                    dispatch(
                        logTransaction("Fetch Mood Assessment Levels", url)
                    )
                }
            })
            .catch(error => {
                console.log("error", error)
                dispatch(
                    logTransaction("Fetch Mood Assessment Levels Failed", url)
                )
            })
    }
}

export function fetchActivityLog(
    patientUserId,
    startDate,
    endDate,
    success,
    failure,
    page,
    pageSize
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url =
            activityURL +
            `?relatedPatientUserId=${patientUserId}&from=${startDate}&to=${endDate}&pageNo=${page}&pageSize=${pageSize}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(logTransaction("Fetch Activity log ", response))
                    dispatch(updateActivityLogs(response.data.responseData))
                    success()
                } else {
                    dispatch(updateActivityLogs([]))
                    failure("No activity logs available")
                }
            })
            .catch(err => {
                dispatch(updateActivityLogs([]))
                failure("Failed to fetch activity logs")
            })
    }
}

export function fetchActivityLogCount(
    patientUserId,
    startDate,
    endDate,
    success,
    failure
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url =
            activityURL +
            `?relatedPatientUserId=${patientUserId}&from=${startDate}&to=${endDate}&isCount=true&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    console.log("response of activity log action", response)
                    dispatch(logTransaction("Fetch Activity log ", response))
                    success(response.data.responseData)
                } else {
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                failure("Failed to fetch activity logs count")
            })
    }
}

export function insertActivityLog(activityId, activityName) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const patient = getState().patients.selectedPatient
        const inputData = {
            activityName,
            relatedPatientUserId: patient.userId,
            ...activityEntities[activityId],
        }
        let url = activityURL
        axiosPost(url, { ...inputData, programId: program.id })
            .then(response => {
                if (response.data.dtatusCD == 200) {
                    console.log("response of insert Activity Log", response)
                    dispatch(logTransaction("Insert activity Log", response))
                } else {
                    dispatch(
                        logTransaction("Insert Activity log failed", response)
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert Activity Log failed", err))
            })
    }
}

export function fetchTempNotes(userId, success, failure) {
    return function (dispatch, getState) {
        dispatch(updatePatientNotes([]))
        let program = getState().user?.program
        let url =
            tempNotesURL + `?patientUserId=${userId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        updatePatientNotes(
                            response.data.responseData.filter(
                                note => !note.isDeleted
                            )
                        )
                    )
                    success(
                        response.data.responseData.filter(
                            note => !note.isDeleted
                        )
                    )
                    console.log(response.data.responseData, "response success")
                } else {
                    dispatch(updatePatientNotes([]))
                    failure && failure(response.data.statusMSG)
                    console.log(response.data.responseData, "response success")
                }
                dispatch(logTransaction("Fetch temp notes success", response))
            })
            .catch(error => {
                dispatch(updatePatientNotes([]))
                failure && failure("Error occured while fetching notes")
                console.log(error, "response error")
                dispatch(
                    logTransaction("Fetch temp notes Failed", error, userId)
                )
            })
    }
}

export function fetchAllNotes(userId, success, failure) {
    return function (dispatch, getState) {
        // dispatch(updatePatientNotes([]))
        let program = getState().user?.program
        let url =
            fetchAllNotesURL +
            `?patientUserId=${userId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        updatePatientNotes(
                            response.data.responseData.filter(
                                note => !note.isDeleted
                            )
                        )
                    )
                    success &&
                        success(
                            response.data.responseData.filter(
                                note => !note.isDeleted
                            )
                        )
                    console.log(response.data.responseData, "response success")
                } else {
                    dispatch(updatePatientNotes([]))
                    failure && failure(response.data.statusMSG)
                    console.log(response.data.responseData, "response success")
                }
                dispatch(logTransaction("Fetch all notes success", response))
            })
            .catch(error => {
                dispatch(updatePatientNotes([]))
                failure && failure("Error occured while fetching notes")
                console.log(error, "response error")
                dispatch(
                    logTransaction("Fetch all notes Failed", error, userId)
                )
            })
    }
}

export function PatientUpcomingAppointments(success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const selectedPatient = getState().patients.selectedPatient
        let url =
            getUpcomingAppointmentsURL +
            `/${selectedPatient.userId}?programId=${
                program.id
            }&clinicId=${selectedPatient?.clinicId}&orgId=${selectedPatient?.organizationId}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        fetchUpcomingAppointments(response.data.responseData)
                    )
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    dispatch(fetchUpcomingAppointments([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(fetchUpcomingAppointments([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function patientOverview(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const selectedPatient = getState().patients.selectedPatient
        let url = `${overviewURL}`
        axiosPostCarePlanAI(
            url,
            JSON.stringify({
                ...data,
                programId: program.id,
                organizationId: selectedPatient?.organizationId,
                clinicId: selectedPatient?.clinicId,
            })
        )
            .then(response => {
                console.log(response, "nghjghjghj")
                if (response.data.status === 200) {
                    if (typeof response.data.response !== null)
                        success(data, response.data.response)
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure && failure(err)
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function assessmentRecommendations(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = `bhnRecommendations`
        axiosPostCarePlanAI(
            url,
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                console.log(response, "nghjghjghj")
                if (response.data.status === 200) {
                    success(response.data.response)
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure && failure(err)
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function getSDOHStatusByPatient(userId, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url =
            getSDOHStatusByPatientURL +
            `?patientUserId=${userId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    console.log(
                        response.data.responseData,
                        response.data.responseData !== null,
                        "klfjsdlf"
                    )
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch SDOH status by patient success",
                            response
                        )
                    )
                } else {
                    failure("No data available")
                    dispatch(
                        logTransaction(
                            "Fetch SDOH status by patient failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure(err)
                dispatch(
                    logTransaction("Fetch SDOH status by patient failed", err)
                )
            })
    }
}

export function fetchAssessmentGraphData(userId, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url =
            assessmentBreakupGraphURL +
            `?patientUserId=${userId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (
                    (response.data.statusCD === 200,
                    response.data.responseData !== null &&
                        response.data.responseData.length > 0)
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch assessment brakup success",
                            response
                        )
                    )
                } else {
                    failure(response.data.statusMSG || "No data available")
                    dispatch(
                        logTransaction(
                            "Fetch assessment brakup failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure("Error occured while fetching assessment graph data")
                dispatch(logTransaction("Fetch assessment brakup failed", err))
            })
    }
}

export function updateHealthHistoryData(patientId, data, success, failed) {
    return function (dispatch, getState) {
        let url = patientsURL
        url = `${url}/${patientId}/medicalHistory`
        axiosPut(url, data)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                    dispatch(logTransaction("Insert or  Health History", data))
                } else {
                    failed(
                        response.data.statusMSG ||
                            "Failed to insert health history"
                    )
                    dispatch(
                        logTransaction(
                            "Insert or Update Health History Failed",
                            data
                        )
                    )
                }
            })
            .catch(err => {
                failed(err)
                dispatch(
                    logTransaction(
                        "Insert or Update Health History Failed",
                        data
                    )
                )
            })
    }
}

export function fetchHealthHistory(patientId, success, failure) {
    return function (dispatch, getState) {
        dispatch(logTransaction("fetch HEalth history Records", patientId))
        axiosGet(`${patientsURL}/${patientId}/medicalHistory`)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData !== null
                ) {
                    dispatch(
                        logTransaction(
                            "fetch HEalth history Records",
                            response,
                            patientId
                        )
                    )
                    success(response.data.responseData)
                } else {
                    failure("No data available")
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction(
                        "fetch HEalth history Records failed",
                        err,
                        patientId
                    )
                )
                failure(err)
            })
    }
}

export const fetchClinicBasedBHNList = (clinicId, success, failure, type) => {
    // console.log("fetchPatients dataSource", dataSource)
    return (dispatch, getState) => {
        // dispatch(fetchPatientsSuccess([]))
        let user = getState().login?.user
        const program = getState().user.program
        // let clinic =
        //     clinicId === undefined || clinicId === ""
        //         ? user?.clinicListForUser?.[0]?.clinicId
        //         : clinicId

        let url = fetchClinicBasedBHNListURL + `?clinicId=${clinicId}`
        if (type) url += `&type=${type}`
        // dispatch(fetchPatientsRequest())

        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    var patients = response.data.responseData || []
                    // dispatch(logTransaction("Fetch Patients", response))
                    // dispatch(fetchPatientsSuccess(patients))
                    success && success(response.data.responseData)
                } else {
                    // dispatch(logTransaction("Fetch Patients", response))
                    // dispatch(fetchPatientsFailure(response.data.statusMSG))
                    failure &&
                        failure(
                            response.data.statusMSG ||
                                "Failed to fetch bhn's list"
                        )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Patients failure", err))
                dispatch(fetchPatientsFailure(err.message))
                failure && failure("Failed to fetch patients")
            })
    }
}

export function fetchCarePlanSuggestion(
    data,
    scoreList,
    success,
    failed,
    updatedCareplanRequirements,
    careplanId
) {
    return async function (dispatch, getState) {
        let url = ""
        let patient = getState().patients.selectedPatient
        const program = getState().user.program
        // url = `${FetchCarePlanFromBackend}?patientId=${patient.patientId}`
        // let BEData = await axiosDoctoriteAiInstance("GET", url)
        // if(BEData.data.responseData && BEData.data.responseData.length) {
        //   return success(BEData.data.responseData)
        // }
        let healthHistory = getState().patients.healthHistory
        let hobbies = []
        let hobby = healthHistory?.filter(e => e.id === 14)
        if (hobby?.length > 0) {
            hobby[0].options.map(e => {
                if (e.isSelected === true) {
                    hobbies.push(e.optionValue)
                }
            })
        }
        let caregiver = false
        let caregiverArray = healthHistory?.filter(e => e.id === 15)
        if (caregiverArray?.length > 0) {
            caregiverArray[0].options.map(e => {
                if (e.isSelected === true && e.id === 1500002) {
                    caregiver = true
                }
            })
        }
        let employed = false
        let employedArray = healthHistory?.filter(e => e.id === 16)
        if (employedArray?.length > 0) {
            employedArray[0].options.map(e => {
                if (
                    e.isSelected === true &&
                    (e.id === 1600001 || e.id === 1600002)
                ) {
                    employed = true
                }
            })
        }
        let productive = ""
        let productiveArray = healthHistory?.filter(e => e.id === 17)
        if (productiveArray?.length > 0) {
            productiveArray[0].options.map(e => {
                if (e.isSelected === true) {
                    productive = e.optionValue
                }
            })
        }
        let sleepHabits = []
        let sleepHabitsArray = healthHistory?.filter(e => e.id === 18)
        if (sleepHabitsArray?.length > 0) {
            sleepHabitsArray[0].options.map(e => {
                if (e.isSelected === true) {
                    sleepHabits.push(e.optionValue)
                }
            })
        }
        const scores_list = [...getState().patients.patientAssessments]
            .filter(assessment => assessment.score)
            .map(assessment => {
                return { name: assessment.mcqName, score: assessment.score }
            })
        var payload = {
            gender: patient.genderDesc || "undefined",
            age: moment().diff(patient.dob, "years").toString(),
            diseases: "",
            // "scores": data.toString(),
            scores_list: scores_list,
            hobbies: hobbies,
            caregiver_at_home: caregiver,
            employed: employed,
            most_productive_time: productive,
            sleep_habits: sleepHabits,
            programId: program.id,
            // "questions": [{ "question": "Feeling down, depressed", "answer": "More than half days" }]
            previous_questions:
                updatedCareplanRequirements?.slice(
                    0,
                    updatedCareplanRequirements.length - 1
                ) || [],
            ...(updatedCareplanRequirements?.length
                ? {
                      question:
                          updatedCareplanRequirements[
                              updatedCareplanRequirements.length - 1
                          ].content,
                  }
                : {}),
        }
        for (let i = 1; i < payload.previous_questions.length; i++) {
            if (
                payload.previous_questions[i].author ===
                payload.previous_questions[i - 1].author
            ) {
                payload.previous_questions = []
                break
            }
        }
        axiosPostCarePlanAI(url, payload)
            .then(response => {
                if (response.status == 200) {
                    axiosPostCarePlanAI(
                        "carePlanGen",
                        JSON.stringify({
                            ...payload,
                            long_term: response.data.response.long_term_goal,
                            short_term: response.data.response.short_term_goal,
                            programId: program.id,
                        }),
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    )
                        .then(response => {
                            success &&
                                success(
                                    {
                                        ...response.data,
                                        points: response.data.response,
                                    },
                                    payload,
                                    careplanId
                                )
                            console.log(
                                "Response: sdkjbnksvc",
                                response.data.response
                            )
                        })
                        .catch(error => {
                            failed && failed()
                            console.error("Error:", error)
                        })
                    // success(response.data, payload, careplanId)
                    // dispatch(logTransaction("Care Plan Suggestion", response))
                    // console.log(response.data, "This is executed")
                } else {
                    failed()
                    dispatch(
                        logTransaction("Care Plan Suggestion Failed", response)
                    )
                }
            })
            .catch(error => {
                console.log(error, " error in care plan")
                failed()
                dispatch(logTransaction("Care Plan Suggestion Failed", error))
            })
    }
}

export function airesponseStoring(data, success, failure) {
    return function (dispatch, getState) {
        let url = `${aiResponseURL}`
        const program = getState().user.program
        axiosDoctoriteAiInstance(
            "POST",
            url,
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData)
                    console.log(response.data.responseData, "This is executed")
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure(response)
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function airesponseDisplay(success, failure, headers = []) {
    return function (dispatch, getState) {
        let url =
            `${aiDisplayingURL}` +
            `?patientUserId=${getState().patients.selectedPatient.userId}`
        if (headers.length > 0)
            headers.map(header => (url += `&headers=${header}`))
        axiosDoctoriteAiInstance("GET", url)
            .then(response => {
                console.log(response.data, "This is executed")
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0 &&
                    response.data.responseData[0]?.aiResponse.length > 0
                ) {
                    success(response.data.responseData)
                    dispatch(fetchAianswers(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure()
                    dispatch(fetchAianswers([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                console.log(err, "error incatch block ")
                failure()
                dispatch(fetchAianswers([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function getAiResponseHeaders(headers, success, failure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        let url =
            `${aipatientHeadersURL}` +
            `?patientUserId=${
                getState().patients.selectedPatient.userId
            }&programId=${program.id}`
        if (headers) url += `&headers=${headers.join(",")}`
        axiosDoctoriteAiInstance("GET", url)
            .then(response => {
                console.log(response.data, "This is executed")
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData !== null
                ) {
                    success(response.data.responseData)
                    dispatch(fetchAianswers(response.data.responseData))
                    dispatch(fetchAIHeaders(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure(response.data.responseData)
                    dispatch(fetchAianswers([]))
                    dispatch(fetchAIHeaders([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                console.log(err, "error incatch block ")
                failure()
                dispatch(fetchAianswers([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function getAiCareGoalHeaders(id, success, failure) {
    return function (dispatch, getState) {
        let url = `${aiCaregoalURL}` + `/${id}`
        axiosDoctoriteAiInstance("GET", url)
            .then(response => {
                console.log(response.data, "This is executed")
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData !== null
                ) {
                    success(response.data.responseData)

                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure(response.data.responseData)

                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                console.log(err, "error incatch block ")

                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function screen54(success, failure) {
    return function (dispatch, getState) {
        const id = getState().patients.selectedPatient.userId
        const userProfileid = getState().login.userProfile.userId
        console.log("lkdfjlsdfj")
        const overviewSucees = (data, aiData) => {
            //let userProfileid = Object.keys(getState().login.user.userProfile)[0]
            //const user = useSelector(state => state.login.userProfile)
            console.log(data, "lkfjsdlfj")
            console.log(typeof aiData, "lkfjsdlfj")
            // setIsLoading(false)
            let aiStoringData = {
                patientUserId: id,
                question: `Below is the data of a patient (You don't know the name, gender anything about the patient)\n    Patient Health Check: {item.patient_health_check}\n    Test Scores: {scores_string}\n    Care Plan: {care_plan_adherence}\n    Latest Conversation: {latest_conversation}\n\n    I need the following information in a JSON format\n    1. Recommendation to the patient\n    2. Summary about the patient\n    3. Health information about the patient\n    4. Behavior Traits\n\n    in the following formats\n    {\n        recommendation: <string>,\n        summary: <string>,\n        health_information: <string>,\n        behavior_traits: <string>\n    }`,
                createdBy: userProfileid,
                parameter: [],
                aiResponse: [],
            }
            if (typeof aiData !== "string") {
                Object.keys(aiData).forEach(key => {
                    aiStoringData.aiResponse.push({
                        header: key,
                        answer: aiData[key],
                    })
                })
                const params = []
                Object.keys(data).forEach(key => {
                    params.push(`${key}:${JSON.stringify(data[key])}`)
                })
                aiStoringData.parameter = params
                dispatch(airesponseStoring(aiStoringData))
                // setAiData(aiData)
            } else {
                // setAiData(aiData)
            }
            success(aiData)
        }
        const overviewFailure = err => {
            failure(err)
            console.log("gugukyg")
        }
        const transcriptSuceess = callData => {
            console.log(callData, "dhfur")
            const keysArray = Object.keys(callData)
                .map(Number)
                .sort((a, b) => b - a)
            console.log(keysArray, "guygy")
            let latestTranscript = []
            for (let key of keysArray) {
                console.log(callData[key], "jslfjsldkf")
                if (Object.keys(callData[key]).length > 0) {
                    latestTranscript = callData[key].transcripts
                    break
                }
            }
            console.log(latestTranscript, "hguyguyg")
            const transcriptString = latestTranscript.join(" ")
            console.log(transcriptString, "ewhuy")
            return transcriptString || ""
        }

        const mcqSuccess = mcqData => {
            console.log(mcqData, "hfdiuerf")
            const uniqueAssessmentData = mcqData
                .filter(item => item.score !== null)
                .reduce((accumulator, currentItem) => {
                    const existingItemIndex = accumulator.findIndex(
                        item => item.name === currentItem.mcqName
                    )

                    if (existingItemIndex === -1) {
                        accumulator.push({
                            name: `${currentItem.mcqName.split(" ")[0]} test`,
                            score: currentItem.score,
                        })
                    } else {
                        if (
                            currentItem.score >
                            accumulator[existingItemIndex].score
                        ) {
                            accumulator[existingItemIndex].score =
                                currentItem.score
                        }
                    }

                    return accumulator
                }, [])
            return uniqueAssessmentData
        }

        const phcSucess = data => {
            if (data && data.length > 0) {
                const processedData = {}

                data.forEach(item => {
                    processedData[item.question] = item.options
                        .filter(option => option.isSelected)
                        .map(option => option.optionValue)
                })
                return processedData
                //setPhcData(processedData);
            }
        }
        const fetchMCQDoneByIdPromise = new Promise((resolve, reject) => {
            dispatch(fetchMCQDoneById(id, 1, resolve, resolve))
        })
        const fetchUserJournalActivitiesPromise = new Promise(
            (resolve, reject) => {
                dispatch(fetchUserJournalActivities(id, resolve, resolve))
            }
        )
        const fetchHealthHistoryPromise = new Promise((resolve, reject) => {
            dispatch(fetchHealthHistory(id, resolve, resolve))
        })
        const fetchTranscriptsPromise = new Promise((resolve, reject) => {
            dispatch(fetchTranscripts(id, resolve, resolve))
        })
        Promise.all([
            fetchMCQDoneByIdPromise,
            fetchUserJournalActivitiesPromise,
            fetchHealthHistoryPromise,
            fetchTranscriptsPromise,
        ])
            .then(([mcq, journal, phc, transcripts]) => {
                console.log(mcq, "abcdefghij")
                console.log(journal, "abcdefghij")
                console.log(phc, "abcdefghij")
                console.log(transcripts, "abcdefghij")
                let test_scores = []
                let care_plan = ""
                let care_plan_adherence = []
                let latest_conversation = ""
                let patient_health_check = {}
                if (mcq && typeof mcq !== "string" && mcq.length !== 0) {
                    test_scores = mcqSuccess(mcq)
                    console.log(test_scores, "abcdefghijkl")
                }
                if (phc && typeof phc !== "string" && phc.length !== 0) {
                    patient_health_check = phcSucess(phc)
                    console.log(patient_health_check, "abcdefghijkl")
                }
                if (transcripts && typeof transcripts !== "string") {
                    console.log(transcripts, "ghhjghghg")
                    latest_conversation = transcriptSuceess(transcripts)
                    console.log(latest_conversation, "abcdefghijkl")
                }
                if (
                    journal &&
                    typeof journal !== "string" &&
                    journal.length !== 0
                ) {
                    care_plan = journal[0].title
                    console.log(care_plan, "hyjghiuh")
                    const fetchUserCareActivitiesPromise = new Promise(
                        (resolve, reject) => {
                            dispatch(
                                fetchUserCareActivities(
                                    journal[0].id,
                                    resolve,
                                    resolve
                                )
                            )
                        }
                    )
                    fetchUserCareActivitiesPromise.then(value => {
                        if (
                            value &&
                            typeof value !== "string" &&
                            value.length > 0
                        ) {
                            const transformedData = value.map(activity => {
                                return {
                                    activity_name:
                                        activity.category.lookupDescription,
                                    interval: activity.frequency.lookupValue,
                                    status: "",
                                }
                            })
                            care_plan_adherence = [...transformedData]
                            dispatch(
                                patientOverview(
                                    {
                                        patient_health_check,
                                        test_scores,
                                        care_plan_adherence,
                                        care_plan,
                                        latest_conversation: [
                                            {
                                                author: "user",
                                                message: latest_conversation,
                                            },
                                        ],
                                    },
                                    overviewSucees,
                                    overviewFailure
                                )
                            )
                        } else {
                            dispatch(
                                patientOverview(
                                    {
                                        patient_health_check,
                                        test_scores,
                                        care_plan_adherence,
                                        care_plan,
                                        latest_conversation: [
                                            {
                                                author: "user",
                                                message: latest_conversation,
                                            },
                                        ],
                                    },
                                    overviewSucees,
                                    overviewFailure
                                )
                            )
                        }
                    })
                } else {
                    dispatch(
                        patientOverview(
                            {
                                patient_health_check,
                                test_scores,
                                care_plan_adherence,
                                care_plan,
                                latest_conversation: [
                                    {
                                        author: "user",
                                        message: latest_conversation,
                                    },
                                ],
                            },
                            overviewSucees,
                            overviewFailure
                        )
                    )
                }
            })
            .catch(err => {
                console.log(err, "jfsdjfjfl")
            })
            .finally(() => {
                console.log("jfsdjfjfl")
            })
    }
}

export function nextAssessmentRecommendations(data, success, failure) {
    return function (dispatch, getState) {
        // let url = `assessmentRecommendations`
        // axiosPostCarePlanAI('http://127.0.0.1:8000/assessmentRecommendations', JSON.stringify(data))
        const program = getState().user.program
        axiosPostCarePlanAI(
            "assessmentRecommendations",
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                console.log(response, "nghjghjghj")
                if (response.data.status === 200) {
                    success(response.data.response)
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure && failure(err)
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function aboutPatient(data, success, failure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        axiosPostCarePlanAI(
            "screen54/aboutPatient",
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                console.log("Response:", response.data.response)
                success && success(data, response.data.response)
            })
            .catch(error => {
                console.error("Error:", error)
                failure && failure(error)
            })
    }
}

export function patientHealthInfo(data, success, failure) {
    return function (dispatch, getState) {
        // axios.post('http://127.0.0.1:8000/screen54/patientHealthInfo', JSON.stringify(data), {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // })
        const program = getState().user.program
        axiosPostCarePlanAI(
            "screen54/patientHealthInfo",
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                success && success(data, response.data.response)
                console.log("Response:", response.data.response)
            })
            .catch(error => {
                failure && failure(error)
                console.error("Error:", error)
            })
    }
}

export function bhnRecommendations(data, success, failure) {
    return function (dispatch, getState) {
        // axios.post('http://127.0.0.1:8000/bhnRecommendations', JSON.stringify(data), {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // })
        const program = getState().user.program
        axiosPostCarePlanAI(
            "bhnRecommendations",
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                dispatch(
                    updateLatestBhnRecommendations({
                        assessmentName: data.assessmentName,
                        recommendations: response.data.response.recommendations,
                    })
                )
                success && success(data, response.data.response)
                console.log("Response:", response.data.response)
            })
            .catch(error => {
                failure && failure(error)
                console.error("Error:", error)
            })
    }
}

export function behaviorTraits(data, success, failure) {
    return function (dispatch, getState) {
        // axios.post('http://127.0.0.1:8000/screen54/behaviorTraits', JSON.stringify(data), {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // })
        const program = getState().user.program
        axiosPostCarePlanAI(
            "screen54/behaviorTraits",
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                console.log("Response:", response.data.response)
                success && success(data, response.data.response)
            })
            .catch(error => {
                console.error("Error:", error)
                failure && failure(error)
            })
    }
}

export function carePlanGenerator(data, success, failure) {
    return function (dispatch, getState) {
        // axios.post('http://127.0.0.1:8000/', JSON.stringify(data), {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // })
        const program = getState().user.program
        axiosPostCarePlanAI(
            "/",
            JSON.stringify({ ...data, programId: program.id })
        )
            .then(response => {
                success && success(data, response.data.points)
                console.log("Response:", response.data.response)
            })
            .catch(error => {
                failure && failure()
                console.error("Error:", error)
            })
    }
}

export function fetchDocAssisstAnswers(userId, programId, success, failure) {
    return function (dispatch, getState) {
        let url =
            docAssisstAnswersURL +
            `?patientUserId=${userId}&programId=${programId}`
        axiosDoctoriteAiInstance("GET", url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (
                    (response.data.statusCD === 200,
                    response.data.responseData !== null)
                ) {
                    success && success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch Doc Assisst Answer success",
                            response
                        )
                    )
                } else {
                    failure &&
                        failure(response.data.statusMSG || "No data available")
                    dispatch(
                        logTransaction(
                            "Fetch aDoc Assisst Answer failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure &&
                    failure(
                        err,
                        "Error occured while fetching Doc Assisst Answer data"
                    )
                dispatch(logTransaction("Fetch Doc Assisst Answer failed", err))
            })
    }
}

export function intimatePatientEmergency(data, success, failed) {
    return function (dispatch, getState) {
        let url =
            intimatePatientEmergencyURL +
            `/${data.userId}?message=${data.message}&subject=${data.subject}`
        axiosPost(url, {})
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response)
                    dispatch(logTransaction("Send Email To Patient", url))
                } else {
                    failed()
                    dispatch(
                        logTransaction("Send Email To Patient Failed", url)
                    )
                }
            })
            .catch(error => {
                failed()
                dispatch(logTransaction("Send Email To Patient Failed", url))
            })
    }
}

export function intimateUserEmail(data, success, failed) {
    return function (dispatch, getState) {
        let url =
            intimateUserEmailURL +
            `/${data.userId}?message=${data.message}&subject=${data.subject}`
        axiosPost(url, {})
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response)
                    dispatch(logTransaction("Send Email To Patient", url))
                } else {
                    failed()
                    dispatch(
                        logTransaction("Send Email To Patient Failed", url)
                    )
                }
            })
            .catch(error => {
                failed()
                dispatch(logTransaction("Send Email To Patient Failed", url))
            })
    }
}

export function sendSmsToPatient(data, success, failed) {
    return function (dispatch, getState) {
        let url = sendSmsToPatientURL + `?message=${data.message}`
        if (data?.mobileNo) url += `&toPhone=${data.mobileNo}`
        if (data?.organizationIds)
            url += `&organizationIds=${data.organizationIds}`
        if (data?.clinicIds) url += `&clinicIds=${data.clinicIds}`
        if (data?.patientIds) url += `&patientIds=${data.patientIds}`
        if (data.hasOwnProperty("isActive")) url += `&isActive=${data.isActive}`
        const formData = new FormData()
        if (data?.mediaUrl) {
            formData.append("mediaUrl", data.mediaUrl)
            axiosPost(url, formData, {
                "Content-Type": "multipart/form-data",
            })
                .then(response => {
                    if (response.data.statusCD == 200) {
                        success(response)
                        dispatch(logTransaction("Send Sms To Patient", url))
                    } else {
                        failed()
                        dispatch(
                            logTransaction("Send Sms To Patient Failed", url)
                        )
                    }
                })
                .catch(error => {
                    failed()
                    dispatch(logTransaction("Send Sms To Patient Failed", url))
                })
        } else {
            axiosPost(
                url,
                {},
                {
                    "Content-Type": "application/json",
                }
            )
                .then(response => {
                    if (response.data.statusCD == 200) {
                        success(response)
                        dispatch(logTransaction("Send Sms To Patient", url))
                    } else {
                        failed()
                        dispatch(
                            logTransaction("Send Sms To Patient Failed", url)
                        )
                    }
                })
                .catch(error => {
                    failed()
                    dispatch(logTransaction("Send Sms To Patient Failed", url))
                })
        }
    }
}

export function intimateItSupport(
    data,
    success = () => {},
    failed = () => {},
    type = ""
) {
    return function (dispatch, getState) {
        console.log(type, "sfkjldslkfjdlfj")
        try {
            axiosGet(
                type == "support" ? itSupportEmailURL : hardAlertemailURL
            ).then(response => {
                if (response?.data?.responseData) {
                    let url =
                        intimateUserEmailURL +
                        `?message=${data.message}&subject=${data.subject}&emails=${response.data.responseData}`
                    const formData = new FormData()
                    if (data?.mediaUrl) {
                        formData.append("attachFile", data.mediaUrl)
                        axiosPost(url, formData, {
                            "Content-Type": "multipart/form-data",
                        })
                            .then(response => {
                                if (response.data.statusCD == 200) {
                                    success(response)
                                    dispatch(
                                        logTransaction(
                                            "Send Sms To Patient",
                                            url
                                        )
                                    )
                                } else {
                                    failed()
                                    dispatch(
                                        logTransaction(
                                            "Send Sms To Patient Failed",
                                            url
                                        )
                                    )
                                }
                            })
                            .catch(error => {
                                failed()
                                dispatch(
                                    logTransaction(
                                        "Send Sms To Patient Failed",
                                        url
                                    )
                                )
                            })
                    } else {
                        axiosPost(
                            url,
                            {},
                            {
                                "Content-Type": "application/json",
                            }
                        )
                            .then(response => {
                                if (response.data.statusCD == 200) {
                                    success(response)
                                    dispatch(
                                        logTransaction(
                                            "Send Sms To Patient",
                                            url
                                        )
                                    )
                                } else {
                                    failed()
                                    dispatch(
                                        logTransaction(
                                            "Send Sms To Patient Failed",
                                            url
                                        )
                                    )
                                }
                            })
                            .catch(error => {
                                failed()
                                dispatch(
                                    logTransaction(
                                        "Send Sms To Patient Failed",
                                        url
                                    )
                                )
                            })
                    }
                } else {
                    throw new Error("Failed to fetch email")
                }
            })
        } catch (err) {
            failed()
            dispatch(logTransaction("Send Sms To Patient Failed"))
            console.log(err, "Failed to intimate IT")
        }
    }
}

export function sendEmail(
    data,
    success = () => {},
    failed = () => {},
    type = ""
) {
    return function (dispatch, getState) {
        let url =
            intimateUserEmailURL +
            `?message=${data.message}&subject=${data.subject}&emails=${data.emails}`
        const formData = new FormData()
        if (data?.mediaUrl) {
            formData.append("attachFile", data.mediaUrl)
            axiosPost(url, formData, {
                "Content-Type": "multipart/form-data",
            })
                .then(response => {
                    if (response.data.statusCD == 200) {
                        success(response)
                        dispatch(logTransaction("Send Sms To Patient", url))
                    } else {
                        failed()
                        dispatch(
                            logTransaction("Send Sms To Patient Failed", url)
                        )
                    }
                })
                .catch(error => {
                    failed()
                    dispatch(logTransaction("Send Sms To Patient Failed", url))
                })
        } else {
            axiosPost(
                url,
                {},
                {
                    "Content-Type": "application/json",
                }
            )
                .then(response => {
                    if (response.data.statusCD == 200) {
                        success(response)
                        dispatch(logTransaction("Send Sms To Patient", url))
                    } else {
                        failed()
                        dispatch(
                            logTransaction("Send Sms To Patient Failed", url)
                        )
                    }
                })
                .catch(error => {
                    failed()
                    dispatch(logTransaction("Send Sms To Patient Failed", url))
                })
        }
    }
}

export function getEmergencyTemplate(success, failed) {
    return function (dispatch, getState) {
        let url = getEmergencyTemplateURL
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                    dispatch(logTransaction("Fetch SMS Template", response))
                } else {
                    failed()
                    dispatch(logTransaction("Fetch SMS Template Failed", url))
                }
            })
            .catch(error => {
                failed()
                dispatch(logTransaction("Fetch SMS Template Failed", url))
            })
    }
}

export function getMessageCenterTemplate(success, failed) {
    return function (dispatch, getState) {
        let url = getMessageCenterTemplateURL
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                    dispatch(logTransaction("Fetch SMS Template", response))
                } else {
                    failed()
                    dispatch(logTransaction("Fetch SMS Template Failed", url))
                }
            })
            .catch(error => {
                failed()
                dispatch(logTransaction("Fetch SMS Template Failed", url))
            })
    }
}

export function longTermandShortTermGoals(data, success, failure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        axiosPostCarePlanAI(
            "/",
            JSON.stringify({ ...data, programId: program.id }),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then(response => {
                success && success(data, response.data.response)
                console.log("Response:", response.data.response)
            })
            .catch(error => {
                failure && failure()
                console.error("Error:", error)
            })
    }
}

export function generateActivities(data, success, failure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        axiosPostCarePlanAI(
            "carePlanGen",
            JSON.stringify({ ...data, programId: program.id }),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then(response => {
                console.log(data, response, "slkfjlksdfjlfjs")
                success && success(data, response.data.response)
                console.log("Response:", response.data.response)
            })
            .catch(error => {
                failure && failure()
                console.error("Error:", error)
            })
    }
}

export function bulkUploadPatients(inputData, success, failure) {
    return function (dispatch, getState) {
        const url =
            uploadPatientsXlsxURL +
            `?orgId=${inputData.orgId}&clinicId=${inputData.clinicId}`
        axiosPost(url, inputData.fileData, {
            "Content-Type": "multipart/form-data",
        })
            .then(response => {
                success("")
                // if (response.data.statusCD == '200' && response.data.responseData) {
                //   success()
                // } else {
                //   failure(response.data.statusMSG || "Failed to upload patients")
                // }
                dispatch(logTransaction("Mass Upload Patients", response))
            })
            .catch(err => {
                failure(err?.msg || "Failed to upload patients")
                dispatch(logTransaction("Mass Upload Patients Failed", err))
            })
    }
}

export function audioUpload(data, success, failure) {
    return function (dispatch, getState) {
        let url = "conversation/media"
        axiosPost(url, data, { "Content-Type": "multipart/form-data" })
            .then(response => {
                if (
                    response.data.statusCD == "200" &&
                    response.data.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(logTransaction("audio uploaded ", response))
                } else {
                    failure("Failed to upload")
                    dispatch(logTransaction("Iupload failed", response))
                }
            })
            .catch(err => {
                dispatch(logTransaction("upload failed", err))
            })
    }
}

export function getAudio(id, success) {
    return function (dispatch, getState) {
        const program = getState().user.program
        let url = `conversation/media?userIds=${id}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    // console.log(response.data.responseData, 'This is executed')
                    dispatch(updateAudios(response.data.responseData))
                    success && success(response.data.responseData)
                    dispatch(logTransaction("fetched audios", response))
                } else {
                    dispatch(updateAudios([]))
                    //  failure && failure()
                    dispatch(logTransaction("audio fetch Failed", url))
                }
            })
            .catch(error => {
                dispatch(updateAudios([]))
                dispatch(logTransaction("audio fetch Failed", error))
            })
    }
}

export function updatePatientManualConsent(patientUserId, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = `callLogs/updatePatinetEhrVerifyAsDone?userId=${patientUserId}&programId=${program.id}`
        axiosPut(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    // console.log(response.data.responseData, 'This is executed')
                    success()
                    dispatch(
                        logTransaction(
                            "update patient manual consent success",
                            response
                        )
                    )
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "update patient manual consent failed",
                            response
                        )
                    )
                }
            })
            .catch(error => {
                failure()
                dispatch(
                    logTransaction(
                        "update patient manual consent failed",
                        error
                    )
                )
            })
    }
}

export function addAssessment(payload, success, failure) {
    let url = createAssessment
    return function (disaptch, getState) {
        axiosPost(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}

export function editAssessment(
    payload,
    success = () => {},
    failure = () => {}
) {
    let url = editAssessmentUrl
    return function (disaptch, getState) {
        axiosPut(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}

export function bulkUpdateCareplan(
    data,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = `${bulkUpdateCareplanUrl}?categoryId=${data?.categoryId}&patientUserId=${data?.patientUserId}&updateLookupId=${data?.updateLookupId}&journalId=${data?.journalId}&programId=${program.id}`
        axiosPutJournal(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction(
                            "Update careplan based on lookup success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure()
                // alert("Goal creation unsuccessfull")
                console.log(err, "created care giak")
                dispatch(
                    logTransaction(
                        "Update careplan based on lookup failed",
                        err
                    )
                )
            })
    }
}

export function updateSummaryStatus(
    data,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        const { patientId, month, year, status } = data
        let program = getState().user?.program
        let url =
            updateSummaryStatusURL +
            `?patientId=${patientId}&month=${month}&year=${year}&status=${status}&programId=${program.id}`
        if (data?.rejectedResponse)
            url += `&rejectedResponse=${data.rejectedResponse}`
        axiosPut(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                    dispatch(logTransaction("Update summary status", response))
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Update summary status", err))
            })
    }
}

export function fetchPatientUploadLog(success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientUploadLogURL + `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction("Retrieve patient upload log", response)
                    )
                } else {
                    failure(
                        response.data.statusMSG ||
                            "Failed to fetch patient upload log"
                    )
                    dispatch(
                        logTransaction("paitent upload log failed", response)
                    )
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("paitent upload log failed", err))
            })
    }
}

export function getPatientDetails(
    patientUserId,
    monthForTimeSpent,
    yearForTimeSpent,
    success,
    failure
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const url =
            getPatientDetailsURL +
            `?patientUserId=${patientUserId}&monthForTimeSpent=${monthForTimeSpent}&yearForTimeSpent=${yearForTimeSpent}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction("Retrieve patient details", response)
                    )
                } else {
                    failure(
                        response.data.statusMSG ||
                            "Failed to fetch patient details"
                    )
                    dispatch(logTransaction("paitent details failed", response))
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("paitent details failed", err))
            })
    }
}

export function updatePayments(data, success = () => {}, failure = () => {}) {
    return function (dispatch, getState) {
        // const {
        //     category,
        //     categoryId,
        //     paidBy,
        //     amount,
        //     paidAmount,
        //     status,
        //     transactionReferenceNo,
        //     paymentMode,
        // } = data
        const url = updatePaymentsURL
        // `?category=${category}&categoryId=${categoryId}&paidBy=${paidBy}&amount=${amount}&paidAmount=${paidAmount}&status=${status}&transactionReferenceNo=${transactionReferenceNo}&paymentMode=${paymentMode}`
        axiosPut(url, data)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                    dispatch(logTransaction("Update payments", response))
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Update payments", err))
            })
    }
}

export function updateAppointmentStatusManually(
    appointmentId,
    status,
    onSuccess,
    onFailure
) {
    return function (dispatch, getState) {
        const url = `${updateAppointmentStatusManuallyUrl}/${appointmentId}?status=${status}`

        axiosPut(url)
            .then(response => {
                dispatch(
                    logTransaction(
                        "Update appointment status manually success",
                        response
                    )
                )
                onSuccess && onSuccess(response?.data)
            })
            .catch(error => {
                dispatch(
                    logTransaction(
                        "Update appointment status manually failed",
                        error
                    )
                )
                onFailure && onFailure(error)
            })
    }
}

export function getPaymentIntentDetails(paymentIntentId, success, failed) {
    return function (dispatch, getState) {
        const url = getPaymentIntentDetailsURL + `?id=${paymentIntentId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    dispatch(
                        logTransaction(
                            "fetch payment intent details success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "fetch payment intent details success",
                            response
                        )
                    )
                    failed("")
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("fetch payment intent details failed", err)
                )
                failed(err)
            })
    }
}

export function updateMultiPayments(
    data,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let url = updateMultiPaymentsURL
        if (data) {
            url += `?paymentIds=${data.paymentIds}&appointmentIds=${data.appointmentIds}&amount=${data.amount}&paymentMode=${data.paymentMode}&paymentIntentId=${data.paymentIntentId}`
        }
        axiosPut(url, data)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                    dispatch(logTransaction("Update multi payments", response))
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Update multi payments", err))
            })
    }
}

export function getConditions(success, failed) {
    return function (dispatch, getState) {
        const url = getConditionsURL
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    dispatch(
                        logTransaction(
                            "fetch program conditions success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "fetch program conditions success",
                            response
                        )
                    )
                    failed("")
                }
            })
            .catch(err => {
                dispatch(logTransaction("fetch program conditions failed", err))
                failed(err)
            })
    }
}

export function getMedications(success, failed) {
    return function (dispatch, getState) {
        const url = getMedicationsURL
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    dispatch(
                        logTransaction(
                            "fetch program medications success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "fetch program medications success",
                            response
                        )
                    )
                    failed("")
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("fetch program medications failed", err)
                )
                failed(err)
            })
    }
}

export function addOrUpdatePatientMedication(payload, success, failure) {
    let url = addOrUpdatePatientMedicationURL
    return function (disaptch, getState) {
        axiosPost(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}

export function addOrUpdatePatientCondition(payload, success, failure) {
    let url = addOrUpdatePatientConditionURL
    return function (disaptch, getState) {
        axiosPost(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}

export function bulkUpdatePatientMedication(payload, success, failure) {
    let url = bulkUpdatePatientMedicationURL
    return function (disaptch, getState) {
        axiosPut(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}

export function bulkUpdatePatientCondition(payload, success, failure) {
    let url = bulkUpdatePatientConditionURL
    return function (disaptch, getState) {
        axiosPut(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}

export function getPatientMedications(data, success, failed) {
    return function (dispatch, getState) {
        const program = getState().user.program
        let url = getPatientMedicatonURL + `?programId=${program.id}`
        if (data?.patientId) {
            url += `&patientId=${data.patientId}`
        }
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    dispatch(
                        logTransaction(
                            "fetch patient medications success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "fetch patient medications success",
                            response
                        )
                    )
                    failed("")
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("fetch patient medications failed", err)
                )
                failed(err)
            })
    }
}

export function getPatientConditions(data, success, failed) {
    return function (dispatch, getState) {
        const program = getState().user.program
        let url = getPatientConditionURL + `?programId=${program.id}`
        if (data?.patientId) {
            url += `&patientId=${data.patientId}`
        }
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    dispatch(
                        logTransaction(
                            "fetch patient condition success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "fetch patient condition success",
                            response
                        )
                    )
                    failed("")
                }
            })
            .catch(err => {
                dispatch(logTransaction("fetch patient condition failed", err))
                failed(err)
            })
    }
}

export function emailCCMResponsesToClinic(data, success, failure) {
    return (dispatch, getState) => {
        let program = getState().user?.program
        // .get(fetchCompletedByCategory + `?patientId=${journal.patientId}&categoryId=${journal.category.lookupId}&journalId=${journal.id}`)
        axiosGet(
            emailCCMResponse +
                `?patientUserId=${data.userId}&programId=${program.id}&month=${
                    new Date().getMonth() + 1
                }&year=${new Date().getFullYear()}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    success && success(response.data.responseData)
                } else {
                    failure && failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                failure && failure("Error occured while fetching notes")
            })
    }
}

export function deleteNotes(id, success, failure) {
    return (dispatch, getState) => {
        axiosDelete(notesURL + `/${id}`)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Deleted Notes", response, id))
                    success && success()
                } else {
                    dispatch(logTransaction("Delete Notes Error", response, id))
                    failure && failure()
                }
            })
            .catch(err => {
                failure && failure()
                dispatch(logTransaction("Delete Notes Error", err, id))
            })
    }
}

export function deleteCaregoal(id, success, failure) {
    return (dispatch, getState) => {
        axiosDeleteJournal(careGoalURL + `/${id}`)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Deleted Notes", response, id))
                    success && success()
                } else {
                    dispatch(logTransaction("Delete Notes Error", response, id))
                    failure && failure()
                }
            })
            .catch(err => {
                failure && failure()
                dispatch(logTransaction("Delete Notes Error", err, id))
            })
    }
}

export function deleteCareactivity(id, success, failure) {
    return (dispatch, getState) => {
        axiosDeleteJournal(journalURL + `/${id}`)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Deleted Notes", response, id))
                    success && success()
                } else {
                    dispatch(logTransaction("Delete Notes Error", response, id))
                    failure && failure()
                }
            })
            .catch(err => {
                failure && failure()
                dispatch(logTransaction("Delete Notes Error", err, id))
            })
    }
}

export function fetchRaceList(success, failure) {
    return function (dispatch, getState) {
        let url = lookupsURL + `?lookupCategoryId=${10037}&appLanguageId=1`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    // console.log(
                    //   "response-------------------->>>>>>>>>>>>",
                    //   response.data.responseData
                    // )
                    dispatch(logTransaction("fetch race Success", response))
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch race")
                    dispatch(logTransaction("fetch race failure", response))
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("fetch race failure", err))
            })
    }
}

export function fetchInsurancesList(success, failure) {
    return function (dispatch, getState) {
        let url = lookupsURL + `?lookupCategoryId=${10143}&appLanguageId=1`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    // console.log(
                    //   "response-------------------->>>>>>>>>>>>",
                    //   response.data.responseData
                    // )
                    dispatch(
                        logTransaction("fetch Insurances Success", response)
                    )
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch genders")
                    dispatch(
                        logTransaction("fetch Insurances failure", response)
                    )
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("fetch Insurances failure", err))
            })
    }
}
export function addOrUpdatePatientPaymentMethod(payload, success, failure) {
    console.log(payload, "dlkfjsdlfjdljflkdsjf")
    let url =
        addOrUpdatePatientPaymentMethodUrl + `?patientId=${payload?.patientId}`
    return function (disaptch, getState) {
        axiosPost(url, payload?.paymentMethods || {})
            .then(response => {
                if (response.data.statusCD == 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(e => {
                failure()
            })
    }
}
